<template>
<div class="expertiseBox">
      <div class="notarizaSearch">
          <el-input v-model="notarizaName" placeholder="申请名称"></el-input>
           <el-date-picker
            v-model="createTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="申请日期">
          </el-date-picker>   
          <span class="search" @click="searchFn"></span>
      </div>
      <el-table
      :data="tableData"
        border
      style="width: 100%">
      <template slot="empty">
              <img class="data-pic" src="../../../../assets/images/H5/null.png" alt="" />
              <br/>
              暂无数据
      </template>
      <el-table-column
        prop="expertisePackageName"
         width="180"
        label="申请名称">
      </el-table-column>
      </el-table-column>
      <el-table-column
        label="司法鉴定中心" width="260">
        <template slot-scope="scope">
               海存科仪司法鉴定中心
          </template>
      </el-table-column>
      </el-table-column>
      <el-table-column
        prop="expertiseCenterAddress" width="180"
        label="地址">
      </el-table-column>
      <el-table-column
        prop="userName"  width="130"
        label="申请人">
      </el-table-column>
      <el-table-column
        prop="contractCount"  width="130"
        label="证据数量">
      </el-table-column>
      <el-table-column
        prop="createTime"  width="180"
        label="生成时间">
      </el-table-column>
      <el-table-column  width="130"
        label="操作">
        <template slot-scope="scope">
                <el-button type="text" size="small" @click="lookFn(scope.row.id)">详情</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="showPagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total='total'>
    </el-pagination>
</div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import {mapState} from "vuex"
export default {
  data() {
        return {
          showPagination:false,
           currentPage: 1, //默认第一页
          total: '', //总条数
          pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
          pageSize: 10, //默认第一页展示10条
          tableData: [],
          notarizaName:'',//公证名称
          createTime:'',
          options: [{
          value: '1',
          label: '等待审核'
        }, {
          value: '2',
          label: '等待付费' 
        }, {
          value: '3',
          label: '等待制证'
        }, {
          value: '4',
          label: '已公证'
        }],
        status: ''//当前状态
        }
  },
  methods:{
    init(){
      var queryStr={
        "name":this.notarizaName,
        "createTime":this.createTime,
        "pageNumber":this.currentPage,
        "pageSize":this.pageSize
      }
      if(this.notarizaName) queryStr.name=this.notarizaName;
      if(this.createTime) queryStr.createTime=this.createTime;
      BaseApi.createRpcToken("/Judiciary/judiciaryList", queryStr).then((data) => {   
        if(data.datas.list!=null){
            this.totalRow=data.datas.totalRow
            this.tableData=data.datas.list
          }
        if(data.datas.totalRow>10){
          this.showPaginationp=true;
        }else{
          this.showPaginationp=false;
        }
      }, (data) => {
        console.log(data)
      }) .catch(function(e) {
              errorLog(e);
            });
    },
    lookFn(id){
      this.$router.push({
        path:'serviceHome/evidence',
        query:{
          id:id
        }
      })
    },
    searchFn(){
      this.init()
    },
    handleSizeChangep(val) {
     this.pageSize=val;
     this.init();
    },
    handleCurrentChangep(val) {
      this.currentPage=val;
      this.init();
    }
  },
  created(){
    this.init()
  },
  computed:{
    ...mapState(['currentInfo']),
  },
   watch:{
    "currentInfo"(data){
       this.init()
    }
  }
}
</script>
<style lang="scss">
  .expertiseBox{
    height:100%;
    width: 100%;
    .notarizaSearch{
        width:100%;
        margin-bottom:20px;
        overflow: hidden;
        .el-input{
          height: 30px;
          margin-right: 10px;
          float: left;
            .el-input__inner{
              height: 30px;
              line-height: 28px;
              border-radius: 0;
            }
            .el-input__icon{
              line-height: 28px;
            }
        }
        .el-input:nth-child(1), .el-input:nth-child(2){
          width:180px;
        }
        .el-input:nth-child(3){
          width:193px;
        }
        .el-select{
          float: left;
          .el-input{
            width:100px;
          }
        }
        .search{
          width:30px;
          height: 30px;
          float: left;
          background: url("../../../../assets/images/warning/search_icon_nor.png")no-repeat;
          cursor: pointer;
          img{
            width: 100%;
            height: 100%;
          }
        }
      .search:hover {
        background: url("../../../../assets/images/warning/search_icon_pre.png");
      }
    }
    table{
       width:100%!important;
        border-collapse:none;
       table-layout:auto;
      th,td{
        vertical-align: middle;
        height: 30px;
        padding:0;
      }
      // th:nth-child(1),td:nth-child(1){
      //   width:16.3%;
      // }
      // th:nth-child(2),td:nth-child(2){
      //   width:23.7%;
      // }
      // th:nth-child(3),td:nth-child(3){
      //   width:12.6%;
      // }
      // th:nth-child(4),td:nth-child(4){
      //   width:6%;
      // }
      // th:nth-child(5),td:nth-child(5){
      //   width:13%;
      // }
      // th:nth-child(6),td:nth-child(6){
      //   width:13.5%;
      // }
      // th:nth-child(7),td:nth-child(7){
      //   width:15.9%;
      // }
      th{
        font-size: 14px;
        color: #505050;
        text-align: center;
        background: #F9F9F9;
      }
      td{
        font-size: 12px;
        color: #969696;
        text-align: center;
      }
      .el-button{
        font-size: 12px;
        color: #969696;
        text-decoration: underline;
      }
      .cell{
        text-align: center;
        line-height: 30px;
        padding:0;
      }
    }
    .pageDev{
      float:right;
      margin-top:20px;
    }
  }
</style>